<template>
  <Card
    :title="$t('global.install-certificate')"
    :help="{
      message: $t('global.install-certificate-desc'),
    }"
  >
    <LoadingState v-if="status.isLoading" />
    <ErrorState v-else-if="status.isErrored" />
    <CertificateInstallForm v-else-if="status.isLoaded" :site="site" :certificates="certificates" />
  </Card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CertificateInstallForm from "@/components/smart/forms/CertificateInstallForm";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "CertificateInstall",
  components: {
    Card,
    LoadingState,
    ErrorState,
    CertificateInstallForm,
  },
  props: {
    site: Object,
  },
  setup() {
    const status = computed(() => store.getters["certificates/getStatus"]);
    const certificates = computed(() => store.getters["certificates/getList"]);
    const loading = ref(true);

    onMounted(() => {
      // get available ssl certificates
      store.dispatch("certificates/getList").finally(() => {
        loading.value = false;
      });
    });

    return { certificates, loading, status };
  },
};
</script>
